module.exports = __webpack_public_path__ + "images/icons/icon-profile-a28c1d78.svg";